<nb-card class="container">
  <nb-card-header>{{ matterportAssetName }}</nb-card-header>
  <nb-card-body class="card-body">
    <ngx-matterport-page
      [matterportModelSid]="matterportModelSid"
    ></ngx-matterport-page>
  </nb-card-body>
  <nb-card-footer>
    <div class="float-right">
      <button
        nbButton
        status="primary"
        class="btn-primary btn-outline btn-small"
        (click)="close()"
        i18n="@@matterport-viewer-close-button"
      >
        Close
      </button>
    </div>
  </nb-card-footer>
</nb-card>
<ngx-time-selector></ngx-time-selector>
